import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RentIndexState } from '../../../@types/state-types'
import { RentIndexResponseDto } from '../../../@types/rent-index-types'

export const initialState: RentIndexState = {
  status: 'idle',
  minValue: undefined,
  averageValue: undefined,
  maxValue: undefined,
  lastRequestFingerprint: undefined,
}

const rentIndexFeatureSlice = createSlice({
  name: 'rentIndexFeature',
  initialState,
  reducers: {
    rentIndexRequest(state) {
      state.status = 'pending'
    },
    rentIndexSuccess(
      state,
      action: PayloadAction<{ rentIndexResult: RentIndexResponseDto; requestFingerprint: string }>
    ) {
      state.status =
        action.payload.rentIndexResult.minValue !== undefined &&
        action.payload.rentIndexResult.averageValue !== undefined &&
        action.payload.rentIndexResult.maxValue !== undefined
          ? 'available'
          : 'idle'
      state.minValue = action.payload.rentIndexResult.minValue
      state.averageValue = action.payload.rentIndexResult.averageValue
      state.maxValue = action.payload.rentIndexResult.maxValue
      state.lastRequestFingerprint = action.payload.requestFingerprint
    },
    rentIndexNotAvailable(state, action: PayloadAction<{ requestFingerprint: string }>) {
      state.status = 'notAvailable'
      state.minValue = undefined
      state.averageValue = undefined
      state.maxValue = undefined
      state.lastRequestFingerprint = action.payload.requestFingerprint
    },
    rentIndexError(state, action: PayloadAction<{ requestFingerprint: string }>) {
      state.status = 'error'
      state.minValue = undefined
      state.averageValue = undefined
      state.maxValue = undefined
      state.lastRequestFingerprint = action.payload.requestFingerprint
    },
    rentIndexReset(state) {
      state.status = 'idle'
      state.minValue = undefined
      state.averageValue = undefined
      state.maxValue = undefined
      state.lastRequestFingerprint = undefined
    },
  },
})

export const { rentIndexRequest, rentIndexSuccess, rentIndexNotAvailable, rentIndexError, rentIndexReset } =
  rentIndexFeatureSlice.actions
export default rentIndexFeatureSlice.reducer
